<template>
  <FilterMultiChip
    icon="thermometer"
    :is-text="isText"
    :label="$t('search-filters.relevance-score.name')"
    :items="items"
    :value="selectedValues"
    @change="onChange"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';

// Relevance-score bands ↔ the stored `relevanceScoreRange` ([{start,end}]). Semantically a
// multi-select of bands, but persisted as ranges — so this chip adapts range-objects ↔ band
// value keys around a plain multi chip (like ReadChip adapts array↔value).
const SCORE_BANDS = [
  { value: 'strong', start: 75, end: 100 },
  { value: 'moderate', start: 50, end: 75 },
  { value: 'poor', start: 0, end: 50 },
];

export default {
  name: 'ScoreChip',
  components: { FilterMultiChip },
  props: {
    // relevanceScoreRange: [{ start, end }]
    value: { type: Array, default: () => [] },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return SCORE_BANDS.map((b) => ({ value: b.value, text: this.$t(`search-filters.relevance-score.${b.value}`) }));
    },
    selectedValues() {
      return (this.value || [])
        .map((r) => {
          const band = SCORE_BANDS.find((b) => b.start === r.start && b.end === r.end);
          return band ? band.value : null;
        })
        .filter(Boolean);
    },
  },
  methods: {
    onChange(bandValues) {
      const ranges = bandValues
        .map((v) => SCORE_BANDS.find((b) => b.value === v))
        .filter(Boolean)
        .map((b) => ({ start: b.start, end: b.end }));
      this.$emit('change', ranges);
    },
  },
};
</script>
